import $ from 'jquery'
window.jQuery = window.$ = $

import { I18n } from 'i18n-js'

import '@/src/javascripts/login.js'
import '@/src/javascripts/layout/header.js'
import '@/src/javascripts/session/index.js'
import '@/src/javascripts/settings/users/index.js'
import '@/src/javascripts/settings/users/form.js'
import '@/src/javascripts/settings/permissions/index.js'
import '@/src/javascripts/settings/permissions/form.js'
import '@/src/javascripts/settings/suppliers/index.js'
import '@/src/javascripts/settings/suppliers/form.js'
import '@/src/javascripts/settings/customers/index.js'
import '@/src/javascripts/settings/customers/form.js'
import '@/src/javascripts/settings/units/index.js'
import '@/src/javascripts/settings/units/form.js'
import '@/src/javascripts/public_data/index.js'
import '@/src/javascripts/public_data/form.js'
import '@/src/javascripts/partner/public_data/index.js'
import '@/src/javascripts/material_reports/index.js'
import '@/src/javascripts/material_reports/show.js'
import '@/src/javascripts/supplier/shipping_reports/index.js'
import '@/src/javascripts/supplier/shipping_reports/show.js'
import '@/src/javascripts/customer/shipping_reports/index.js'
import '@/src/javascripts/customer/shipping_reports/show.js'
import '@/src/javascripts/quality_feedbacks/index.js'
import '@/src/javascripts/quality_feedbacks/form.js'
import '@/src/javascripts/partner/quality_feedbacks/index.js'
import '@/src/javascripts/partner/quality_feedbacks/form.js'
import '@/src/javascripts/product_histories/index.js'
import '@/src/javascripts/product_histories/show.js'
import '@/src/javascripts/document/index.js'
import '@/src/javascripts/document/new.js'
import '@/src/javascripts/document/show.js'
import '@/src/javascripts/reports/show.js'

import mySwal from '@/src/javascripts/plugins/mySwal.js'

import * as Turbo from '@hotwired/turbo'
Turbo.start()

let isI18nInitialized = false
const initializingI18n = function () {
  const i18n = new I18n()
  if (window.i18n_locale) {
    i18n.locale = window.i18n_locale
  }

  if (window.i18n_translations) {
    i18n.translations = window.i18n_translations
  }

  window.I18n = i18n
}
document.addEventListener('DOMContentLoaded', () => {
  if (!isI18nInitialized) {
    initializingI18n()
    isI18nInitialized = true
  }
})
$(document).on('turbo:load turbo:render', () => {
  initializingI18n()

  // 表單退出提示
  const $formElement = $('form.leave-need-confirm')

  if ($formElement.length) {
    $(document).on('turbo:before-visit', async (event) => {
      event.preventDefault()

      const isConfirm = await mySwal.confirm({
        title: '表單尚未送出，是否確定離開？',
        confirmButtonText: '確定',
        cancelButtonText: '取消',
        customClass: {
          confirmButton: 'btn m-[0.3125em] bg-scp-royal-blue text-white text-lg hover:bg-blue-800',
          cancelButton: 'btn m-[0.3125em] text-lg btn-ghost'
        },
        buttonsStyling: false
      })

      if (isConfirm) {
        $(document).off('turbo:before-visit')
        const targetUrl = event.originalEvent.detail.url
        Turbo.visit(targetUrl)
      }
    })
  }
  window.addEventListener('popstate', () => {
    $(document).off('turbo:before-visit')
  })
})
